function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	const week_button = document.querySelector("#_week-filter-button");
	const month_button = document.querySelector("#_month-filter-button");

	if (week_button) {
		for (const el of document.querySelectorAll("._months")) {
			const get_weeks = new URL("/film/boxoffice-weeks/", window.origin);
			const week_filter = document.querySelector("#_week-filter");
			el.addEventListener("click", () => {
				week_button.classList.remove("active");
				week_button.classList.add("disabled");
				week_button.textContent = "Settimana";
				for (const li of week_filter.querySelectorAll("li")) {
					li.remove();
				}
				month_button.textContent = el.textContent;
				month_button.classList.add("active");
				get_weeks.searchParams.append("type", week_button.dataset.filterType);
				get_weeks.searchParams.append("month", el.dataset.month);
				get_weeks.searchParams.append(
					"year",
					document.querySelector("#_year-filter-button").dataset.year,
				);
				fetch(get_weeks.toString(), {
					headers: {
						"X-Requested-With": "XMLHttpRequest",
					},
				})
					.then((response) => response.json())
					.then((data) => {
						if (data.weeks.length) {
							for (let i = 0; i < data.weeks.length; i++) {
								const week = data.weeks[i];
								const li = document.createElement("li");
								li.innerHTML = `<a href="?settimana=${week[0]}" class="dropdown-item" rel="nofollow">${week[1]}</a>`;
								week_filter.appendChild(li);
							}
							week_button.classList.remove("disabled");
						}
					})
					.catch((error) => {
						console.warn(error);
					});
			});
		}
	}
});
